import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { concatValueIfPresent } from '@ui/global-shared/util/string-util';
import { UrlHelperService } from '@ui/global-shared/util/url-helper.service';

@Injectable({
  providedIn: 'root',
})
export class ConfirmTokenService {
  private http = inject(HttpClient);
  private urlHelper = inject(UrlHelperService);

  // localhost:8080/signup/xxxxxxxxxxxxxxxx/approve
  public confirmToken(token: string): Observable<void> {
    let url = this.urlHelper.prepareApiPath('signup');
    url = concatValueIfPresent(url, '/' + token, '/approve');
    return this.http.get<void>(url);
  }
}
